<template>
  <form class="question-form">
    <div class="slider">
      <div class="range">
        <input v-model="answer" type="range" min="0" :max="question[question.perspective].answerOptions.length - 1"
               step="1">
        <div class="ticks">
          <template v-for="answer in question[question.perspective].answerOptions">
            <span class="tick"></span>
          </template>
        </div>
      </div>
      <div class="tocks">
        <template v-for="answer in question[question.perspective].answerOptions">
          <span class="tock text-center" v-html="answer.text"></span>
        </template>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: "Slider",
  props: {
    question: {
      required: true,
      type: Object,
      validator: (value) => {
        return value[value.perspective].type === 'Slider'
            && value[value.perspective].answerOptions.length > 0;
      }
    }
  },
  data() {
    return {
      answer: 0
    }
  },
  methods: {
    validateAnswer() {
      return {
        correct: this.question[this.question.perspective].answerOptions[this.answer].isCorrectAnswer,
        missed: false,
        //answers: [this.question[this.question.perspective].answerOptions[this.answer]]
      }
    }
  }
}
</script>

<style lang="scss" scoped>

$vhUnit: 9;
$vwUnit: 16;
@function scaleVh($size) {
  @return #{($size/$vhUnit)}vh;
}

@function scaleVw($size) {
  @return #{($size/$vwUnit)}vw;
}

.slider {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

@mixin range-track {
  -webkit-appearance: none;
  width: 100%;
  color: transparent;
  background: #FFF;
  box-shadow: 0 0 4px 0 rgba(255, 255, 255, 0.5);
  border-radius: 999px;
  border: none;
}

@mixin range-thumb {
  -webkit-appearance: none;
  background: rgb(185, 212, 0);
  box-shadow: 0 0 20px 5px rgb(185, 212, 0);
  z-index: 1001;
}

input[type=range] {
  -webkit-appearance: none;
  display: block;
  margin: 0;
  width: 100%;
  background: transparent;
  cursor: pointer;
}

input[type=range]:focus {
  outline: none;
}

input[type=range]::-webkit-slider-runnable-track {
  @include range-track();
}

input[type=range]::-moz-range-track {
  @include range-track();
}

input[type=range]::-ms-track {
  @include range-track();
}

input[type=range]::-ms-fill-lower {
  display: none;
}

input[type=range]::-ms-fill-upper {
  display: none;
}

input[type=range]::-webkit-slider-thumb {
  @include range-thumb();
}

input[type=range]::-moz-range-thumb {
  @include range-thumb();
}

input[type=range]::-ms-thumb {
  @include range-thumb();
}

.tocks {
  display: flex;
  flex-direction: row;
}

.tocks .tock {
  width: 25%;
  flex: 1;
}

.ticks {
  display: flex;
  justify-content: space-between;
}

.tick-container {
  position: absolute;
  display: flex;
  justify-content: center;
}

.tick {
  position: relative;
  display: flex;
  justify-content: center;
  width: 2px;
  background: rgb(255, 255, 255);
  box-shadow: 0 0 4px 0 rgba(255, 255, 255, 0.5);
  z-index: -1;
}

@media(min-aspect-ratio: 16/9) {
  $thumbRadius: scaleVh(10);
  $thumbHeight: scaleVh(40);
  $thumbMargin: scaleVh(-16);

  .ticks {
    padding: scaleVh(20) scaleVh(10);
  }

  .tick {
    height: scaleVh(30);
    margin-top: scaleVh(-40);
  }

  input[type=range]::-webkit-slider-runnable-track {
    height: scaleVh(10)
  }
  input[type=range]::-moz-range-track {
    height: scaleVh(10)
  }
  input[type=range]::-ms-track {
    height: scaleVh(10)
  }

  input[type=range]::-webkit-slider-thumb {
    height: $thumbHeight;
    width: scaleVh(20);
    border-radius: $thumbRadius;
    margin-top: $thumbMargin;
  }
  input[type=range]::-moz-range-thumb {
    height: $thumbHeight;
    width: scaleVh(20);
    border-radius: $thumbRadius;
    margin-top: $thumbMargin;
  }
  input[type=range]::-ms-thumb {
    height: $thumbHeight;
    width: scaleVh(20);
    border-radius: $thumbRadius;
    margin-top: $thumbMargin;
  }

  .tocks {
    width: scaleVh(890 + (890 / 3));
  }
  .range {
    width: scaleVh(890);
  }

}

@media(max-aspect-ratio: 16/9) {
  $thumbRadius: scaleVw(10);
  $thumbHeight: scaleVw(40);
  $thumbMargin: scaleVw(-16);

  .ticks {
    padding: scaleVw(20) scaleVw(10);
  }

  .tick {
    height: scaleVw(30);
    margin-top: scaleVw(-40);
  }

  input[type=range]::-webkit-slider-runnable-track {
    height: scaleVw(10)
  }
  input[type=range]::-moz-range-track {
    height: scaleVw(10)
  }
  input[type=range]::-ms-track {
    height: scaleVw(10)
  }

  input[type=range]::-webkit-slider-thumb {
    height: $thumbHeight;
    width: scaleVw(20);
    border-radius: $thumbRadius;
    margin-top: $thumbMargin;
  }
  input[type=range]::-moz-range-thumb {
    height: $thumbHeight;
    width: scaleVw(20);
    border-radius: $thumbRadius;
    margin-top: $thumbMargin;
  }
  input[type=range]::-ms-thumb {
    height: $thumbHeight;
    width: scaleVw(20);
    border-radius: $thumbRadius;
    margin-top: $thumbMargin;
  }

  .tocks {
    width: scaleVw(890 + (890 / 3));
  }
  .range {
    width: scaleVw(890);
  }
}


</style>